import { Switch } from 'react-router-dom';
import { useModuleFeatureFlag } from '@/providers/FeatureFlag.provider';
import Integrations from './Integrations/Integrations';
import Plaid from './Plaid/Plaid';
import UpdatePlaidContainer from './Plaid/UpdatePlaid/UpdatePlaidContainer';
import Flinks from './Flinks/Flinks';
import UpdateFlinksContainer from './Flinks/UpdateFlinks/UpdateFlinksContainer';
import Inverite from './Inverite/Inverite';
import UpdateInveriteContainer from './Inverite/UpdateInverite/UpdateInveriteContainer';
import GlobalPayments from './GlobalPayments/GlobalPayments';
import AccountingSoftware from './AccountingSoftware/AccountingSoftware';
import AccountingSoftwarePage from './AccountingSoftware/AccountingSoftwarePage';
import { useLockedFeatures } from '../../providers/LockedFeatures.provider';
import ProtectedRoute from '../../utils/ProtectedRoute';
import { JSX } from 'react';

const Routes = (): JSX.Element => {
  const lockedFeatures = useLockedFeatures();
  const featureFlags = useModuleFeatureFlag('integrations');

  return (
    <Switch>
      <ProtectedRoute
        isAllowed={featureFlags.isEnabled}
        showPermission
        exact
        path="/integrations"
        component={Integrations}
      />

      <ProtectedRoute
        isAllowed={featureFlags.isEnabled}
        showPermission
        exact
        path="/integrations/global-pay"
        component={GlobalPayments}
      />

      {/* Current (Railz) accounting connection flow */}
      <ProtectedRoute
        exact
        path="/integrations/accounting-software"
        isAllowed={!!lockedFeatures.AccountingSoftwareIntegrationEnabled && featureFlags.isEnabled}
        showPermission
      >
        <AccountingSoftware isSettings />
      </ProtectedRoute>

      <ProtectedRoute
        exact
        path="/integrations/accounting-software/connect"
        isAllowed={!!lockedFeatures.AccountingSoftwareIntegrationEnabled && featureFlags.isEnabled}
        showPermission
      >
        <AccountingSoftware isSettings />
      </ProtectedRoute>

      {/* New (ASP) connection & GL setup — orphan pages, reachable by URL only (ID-13335) */}
      <ProtectedRoute
        exact
        path="/accounting/integrations/accounting-software"
        isAllowed={!!lockedFeatures.AccountingSoftwareIntegrationEnabled && featureFlags.isEnabled}
        showPermission
      >
        <AccountingSoftwarePage />
      </ProtectedRoute>

      <ProtectedRoute
        exact
        path="/accounting/integrations/accounting-software/connect"
        isAllowed={!!lockedFeatures.AccountingSoftwareIntegrationEnabled && featureFlags.isEnabled}
        showPermission
      >
        <AccountingSoftwarePage />
      </ProtectedRoute>

      <ProtectedRoute
        isAllowed={!!lockedFeatures.CustomFlinksCredentialsSet && featureFlags.isEnabled}
        showPermission
        exact
        path="/integrations/Flinks"
        component={Flinks}
      />

      <ProtectedRoute
        isAllowed={!!lockedFeatures.CustomFlinksCredentialsSet && featureFlags.isEnabled}
        showPermission
        exact
        path="/integrations/Flinks/Update"
        component={UpdateFlinksContainer}
      />

      <ProtectedRoute
        isAllowed={!!lockedFeatures.CustomPlaidCredentialsSet && featureFlags.isEnabled}
        showPermission
        exact
        path="/integrations/Plaid"
        component={Plaid}
      />

      <ProtectedRoute
        isAllowed={!!lockedFeatures.CustomPlaidCredentialsSet && featureFlags.isEnabled}
        showPermission
        exact
        path="/integrations/Plaid/Update"
        component={UpdatePlaidContainer}
      />

      <ProtectedRoute
        isAllowed={!!lockedFeatures.CustomInveriteCredentialsSet && featureFlags.isEnabled}
        showPermission
        exact
        path="/integrations/Inverite"
        component={Inverite}
      />

      <ProtectedRoute
        isAllowed={!!lockedFeatures.CustomInveriteCredentialsSet && featureFlags.isEnabled}
        showPermission
        exact
        path="/integrations/Inverite/Update"
        component={UpdateInveriteContainer}
      />
    </Switch>
  );
};

export default Routes;
